module.exports = __webpack_public_path__ + "img/offers.ee88358c.svg";